import { render, staticRenderFns } from "./ShoppingListButton.vue?vue&type=template&id=1da8cd86&scoped=true"
import script from "./ShoppingListButton.vue?vue&type=script&lang=ts"
export * from "./ShoppingListButton.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingListButton.vue?vue&type=style&index=0&id=1da8cd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8cd86",
  null
  
)

export default component.exports